import { getContent } from './utils';

export default class ObjParamBuilder {
	constructor(deribitApi, template, object) {
		this.template = template;
		this.values = template.items.reduce((acc, param) => {
			let elContent = getContent(deribitApi, param);
			let name = elContent.name;
			acc[name] = {param: elContent, value: object[name]};
			return acc;
		}, {});
	}

	set(key, value) {
		this.values[key].value = value;
	}

	// it's a bit misleading name, but it's used in RequestBuilder.send() to construct request object
	toString() {
		return Object.entries(this.values).reduce((acc, [key, {value}]) => {
			if (value) {
				acc[key] = value;
			}
			return acc;
		}, {});
	}

	entries() {
		return Object.entries(this.values);
	}
}
